/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaddressnotfound3Inputs */

const en_eventaddressnotfound3 = /** @type {(inputs: Eventaddressnotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not find this address. Please check it or pick a suggestion.`)
};

const de_eventaddressnotfound3 = /** @type {(inputs: Eventaddressnotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Adresse haben wir nicht gefunden. Bitte prüf sie oder wähl einen Vorschlag.`)
};

/**
* | output |
* | --- |
* | "We could not find this address. Please check it or pick a suggestion." |
*
* @param {Eventaddressnotfound3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaddressnotfound3 = /** @type {((inputs?: Eventaddressnotfound3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaddressnotfound3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaddressnotfound3(inputs)
	return de_eventaddressnotfound3(inputs)
});
export { eventaddressnotfound3 as "eventAddressNotFound" }